<template>
  <section class="container">
    <p>发布日期2021年11月16日------ 更新日期2021年11月16日</p>
    <p>一，服务条款</p>
    <p>1.美游美网服务条款的确认</p>
    <p>美游美各项服务的所有权与运作权归深圳畅行宝藏数字文旅科技有限公司（以下简称“美游美”）所有。本服务条款具有法律约束力。当您点选“注册”并通过注册程序，即表示您自愿接受本协议之所有条款，并已成为美游美的注册会员。若您在后续使用过程中对条款有异议，请通过400-608-6166与美游美联系。</p>
    <p>2.服务内容</p>
    <p>2.1美游美网服务的具体内容由美游美根据实际情况提供，美游美对其所提供之服务拥有最终解释权。</p>
    <p>2.2美游美在美游美网上向其会员提供相关网络服务，与相关网络服务有关的设备（如个人电脑、手机、及其他与接入互联网或移动网有关的装置）及所需的费用（如为接入互联网而支付的电话费及上网费、为使用移动网而支付的手机费）均由会员自行负担。</p>
    <p>2.3会员在享用美游美网会员服务的同时，愿意接受来自美游美网提供的广告等各类营销性信息，接收方式包括但不仅限于邮件、短信、APP信息推送等营销性信息包括美游美向会员推送的新产品、促销产品、优惠产品等所有带有广告性质的信息。会员可根据需求申请退订，美游美网将不再推送相关信息。</p>
    <p>3.会员帐号及密码</p>
    <p>您使用手机注册会员成功后，您的手机号即成为登录帐号，并将得到一个登录密码。您应妥善保管该帐号及密码，并对以该帐号进行的所有活动及事件负法律责任。因黑客行为或会员保管疏忽致使帐号、密码被他人非法使用的，美游美不承担任何责任。如您发现任何非法使用会员帐号或安全漏洞的情况，请立即与美游美联系。</p><p>
    <p>4.会员权责<p>
    <p>4.1会员有权按照美游美规定的程序和要求使用美游美向会员提供的各项网络服务，如果会员对该服务有异议，可以与美游美联系以便得到及时解决。<p>
    <p>4.2用户在申请使用美游美网网络服务时，必须向美游美网提供准确的个人资料，如个人资料有任何变动，必须及时更新。<p>
    <p>4.3会员同意接受美游美网通过电子邮件、短信、微信或其他方式向会员发送促销或其他相关商业广告类信息，此类信息包括但不限于新产品、优惠产品、促销产品等。<p>
    <p>4.4会员在美游美网的网页上发布信息或者利用美游美网的服务时必须符合国家的法律法规以及国际法的有关规定。<p>
    <p>4.5对于会员通过美游美网网上消息平台（包括但不限于论坛、BBS）上传到美游美网网站上可公开获取区域的任何内容，会员同意授予美游美在全世界范围内享有完全的、免费的、永久性的、不可撤销的、非独家的权利，以及再许可第三方的权利，以使用、复制、修改、改编、出版、翻译、据以创作衍生作品、传播、表演和展示此等内容（整体或部分），和/或将此等内容编入当前已知的或以后开发的其他任何形式的作品、媒体或技术中。<p>
    <p>4.6会员承诺不会在美游美网的消息平台（包括但不限于论坛、BBS）发布如下信息：<p>
    <p>.（1）反对宪法所确定的基本原则的；</p>
    <p>.（2）危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；</p>
    <p>.（3）损害国家荣誉和利益的；</p>
    <p>.（4）煽动民族仇恨、民族歧视，破坏民族团结的；</p>
    <p>.（5）破坏国家宗教政策，宣扬邪教和封建迷信的；</p>
    <p>.（6）散布谣言，扰乱社会秩序，破坏社会稳定的；</p>
    <p>.（7）散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；</p>
    <p>.（8）侮辱或者诽谤他人，侵害他人合法权益的；</p>
    <p>.（9）含有法律、行政法规禁止的其他内容的。</p>
    <p>4.7会员单独为其发布在美游美网上的信息承担责任。会员若在美游美网散布和传播违法信息，网络会员服务的系统记录有可能作为会员违法之证据。</p>
    <p>4.8会员不得利用本站的服务从事以下活动：</p>
    <p>.（1）未经允许，进入计算机信息网络或者使用计算机信息网络资源；</p>
    <p>.（2）未经允许，对计算机信息网络功能进行删除、修改或者增加；</p>
    <p>.（3）未经允许，对进入计算机信息网络中存储、处理或者传输的数据和应用程序进行删除、修改或者增加；</p>
    <p>.（4）故意制作、传播计算机病毒等破坏性程序；</p>
    <p>.（5）其他危害计算机信息网络安全的行为。</p>
    <p>4.9会员不得以任何方式干扰本站的服务。</p>
    <p>4.10会员承诺遵守本站的所有其他规定和程序。</p>
    <p>4.11如果会员违反上述规定，美游美有权要求其改正或直接采取一切必要措施（包括但不限于更改或删除会员发布的信息、中断或终止会员使用网络的权利等），以减轻会员不当行为所造成的影响。</p>
    <p>5.服务条款的修改</p>
    <p>美游美有权在必要时修改本服务条款，服务条款的内容一旦发生变动，美游美将会通过适当方式向会员提示修改内容。会员如不同意修改，可以主动选择取消会员资格；如果会员继续使用美游美网服务，将被视为接受修改后的服务条款。</p>
    <p>6．服务内容的修改或中断</p>
    <p>鉴于网络服务的特殊性，美游美保留随时修改或中断其部分或全部网络服务的权利，并无需通知会员或为此对会员及任何第三方负责。</p>
    <p>7．会员隐私保护</p>
    <p>美游美尊重会员的隐私权，不会公开、编辑或泄露任何有关会员的个人资料以及会员在使用网络服务时存储在美游美网的非公开内容，但以下情况除外：</p>
    <p>.（1）事先获得会员的明确授权；</p>
    <p>.（2）遵守法律规定或美游美网合法服务程序；</p>
    <p>.（3）按照相关政府主管部门的合理要求；</p>
    <p>.（4）维护社会公众利益；</p>
    <p>.（5）维护美游美的合法权益；</p>
    <p>.（6）符合其他合法要求。</p>
    <p></p>
    <p>8．中断或终止服务</p>
    <p>如发生下列任何一种情形，美游美有权随时中断或终止向会员提供本协议项下的网络服务，而无需对会员或任何第三方承担任何责任。</p>
    <p>.（1）会员向美游美提供的个人资料不真实。</p>
    <p>.（2）会员违反本协议的规则或不履行其所承担的义务。除此之外，会员可随时根据需要通知美游美终止向该会员提供服务，会员服务终止后，会员使用服务的权利同时终止。自会员服务终止之时起，美游美网不在对该会员承担任何责任。</p>
    <p></p>
    <p>9．知识产权</p>
    <p>9.1美游美在网络服务中提供的任何文本、图片、图形、音频和视频资料均受版权、商标权以及其他相关法律法规的保护。未经美游美事先同意，任何人不能擅自复制、传播这些内容，或用于其他任何商业目的，所有这些资料或资料的任何部分仅可作为个人或非商业用途而保存在某台计算机内。</p>
    <p>9.2美游美为提供网络服务而使用的任何软件（包括但不限于软件中的任何文字、图形、音频、视频资料及其辅助资料）的一切权利属于该软件的著作权人，未经该著作权人同意，任何人不得对该软件进行反向工程、反向编译或反汇编。</p>
    <p>10．免责声明</p>
    <p>10.1美游美对任何因会员不正当或非法使用服务、在网上进行交易、或会员传送信息变动而产生的直接、间接、偶然、特殊及后续的损害不承担责任。</p>
    <p>10.2美游美对任何他人的威胁性的、诽谤性的、淫秽的、令人反感的或非法的内容或行为或对他人权利的侵犯（包括知识产权）不承担责任；并对任何第三方通过服务发送或在服务中包含的任何内容不承担责任。</p>
    <p>10.3会员明确同意其使用美游美网服务所存在的风险以及使用美游美网络服务产生的一切后果由其自己承担。</p>
    <p>10.4对于因不可抗力或美游美网不能控制的原因造成的网络服务中断或其它缺陷，美游美网不承担任何责任，但将尽力减少因此而给用户造成的损失和影响。</p>
    <p>10.5美游美不对所提供之网络服务做任何类型之担保，包括但不限于：</p>
    <p>.（1）网络服务一定能满足会员要求；</p>
    <p>.（2）网络服务不会中断；</p>
    <p>.（3）网络服务的及时性、安全性、准确性。</p>
    <p></p>
    <p>11．赔偿</p>
    <p>因会员对本服务之使用而导致美游美遭受任何来自第三方之纠纷、诉讼及索赔要求，会员同意向美游美及其关联企业、职员赔偿相应损失（包括合理的律师费），并尽力使之免受损害。</p>
    <p>12．通告</p>
    <p>所有发给会员的通告都可以通过重要页面的公告、电子邮件以及常规信件的形式传送。</p>
    <p>13．其他规定</p>
    <p>本服务条款中的标题仅为方便而设，在解释本服务条款时应被忽略。</p>
    <p>二、隐私政策</p>
    <p></p>
    <p>1.收集的信息和方式</p>
    <p>1.1为了更好的给您提供服务及订购产品的必要，我们会需要您提供一些个人信息。当注册成我们会员时，需请您提供您的手机号码或邮箱。注册成功后需请您完善的信息有：中文姓名、英文姓名、性别、出生年月、国籍、移动电话、固定电话、传真号码、邮箱、国家、省份、城市、职业、文化程度、证件。当您在订购产品时，需请您提供旅客姓名、性别、生日、证件号码、联系人、手机号码、邮箱信息、联系地址以及根据您的要求所备注的其他信息。当您选择线上支付时，需请您提供银行卡号、银行预留手机号、持卡人姓名、信用卡到期日，如使用第三方支付的还需提供第三方账户及取得您的授权。</p>
    <p>1.2若您通过美游美为其他旅客订购产品，您需要提交该旅客的上述个人信息，请您确保您已经取得该旅客的同意和授权，并确保该旅客知晓并同意美游美网的隐私政策。</p>
    <p>1.3以下信息会通过您的终端自动收集：</p>
    <p>信息收集的目的</p>
    <p>.（1）我们收集个人信息的目的是为了履行与您签订的合同以及遵守法律义务。</p>
    <p>.（2）若我们将您的个人信息用于本政策未列明的其他用途或者将基于特定目的收集而来的信息用于其他目的时，会事先征求您的明确同意或授权。</p>
    <p>日志信息，指您使用我们的服务时，系统可能通过cookies、webbeacon或其他方式自动采集的技术信息，包括：</p>
    <p>1.3.1设备或软件信息，例如您的移动设备、网页浏览器或用于接入我们服务的其他程序所提供的配置信息、您的IP地址和移动设备所用的版本和设备识别码；</p>
    <p>1.3.2在使用我们服务时搜索或浏览的信息，例如您使用的网页的搜索词语、输入信息，以及您在使用我们服务时浏览或要求提供的其他信息和内容详情；</p>
    <p>1.3.3有关您曾使用的移动应用（APP）和其他软件的信息，以及您曾经使用该等移动应用和软件的信息；</p>
    <p>1.3.4您通过我们的服务进行通讯的信息，例如曾通讯的账号，以及通讯时间、数据和时长；</p>
    <p>1.3.5您通过我们的服务分享的内容所包含的信息（元数据），例如发表的文字、图片、拍摄或上传的共享照片或录像的日期、时间或地点等。</p>
    <p>1.3.6位置信息，指您开启设备定位功能并使用我们基于位置提供的相关服务时，收集的有关您位置的信息，包括：</p>
    <p>1.3.7您通过具有定位功能的移动设备使用我们的服务时，通过GPS或WiFi等方式收集的您的地理位置信息；</p>
    <p>1.3.8您或其他用户提供的包含您所处地理位置的实时信息，例如您提供的账户信息中包含的您所在地区信息，您或其他人上传的显示您当前或曾经所处地理位置的共享信息，您或其他人共享的照片包含的地理标记信息；</p>
    <p>1.4您可以通过关闭定位功能，停止对您的地理位置信息的收集。</p>
    <p>1.5若您是通过第三方接入的方式关联到美游美网的产品，我们会在您对该第三方的授权的前提下获取需要的信息以便订单的处理。</p>
    <p>1.6关于Cookies</p>
    <p>为了让您获得更轻松便捷的访问体验，您访问美游美网站或使用美游美提供的服务时，我们可能会在您的设备终端或系统上存储名为Cookie的小型数据文件用来识别您的身份，这样可以帮您省去重复输入注册信息的步骤，帮您优化对广告的选择与互动及其帮助判断您的账户安全状态。您可以清除计算机或移动设备上保存的所有Cookie，您有权接受或拒绝Cookie，如果浏览器自动接受Cookie，您可以根据自己的需要修改浏览器的设置以拒绝Cookie。请注意，如果您选择拒绝Cookie，那么您可能无法更好地体验美游美提供的服务。</p>
    <p>2.信息使用的可能性</p>
    <p>2.1美游美会将您的信息用于以下目的：</p>
    <p>2.1.1为您订购产品：美游美将使用您的个人信息以完成订单或向您订购产品的所有者提供必要的信息以便确认您的身份。</p>
    <p>2.1.2账户管理：您可通过美游美网页或APP注册账户，管理您的个人信息、订单、评价、旅客管理、支付功能等。</p>
    <p>2.1.4客户服务：美游美提供7*24小时在线及电话客服，解答您的疑问和咨询。</p>
    <p>2.1.5提升服务的安全性和可靠性：美游美可能会检测和预防欺诈行为、不法活动，将您的个人信息用于风险评估和安全目的。</p>
    <p>2.1.6数据分析：美游美可能将个人信息用于分析，以便让我们能够了解您所在的位置、偏好和人口统计信息，或与其他来源（包括第三方）的数据相匹配，从而开发我们的产品、服务或营销计划，改进我们的服务和产品。</p>
    <p>2.1.7日常运营：包括但不限于订单管理、客户验证、技术支持、网络维护、故障排除、内部行政事务及内部政策和程序、生成内部报告等。</p>
    <p>2.1.8电话监测：您接听和拨打我们的客服电话可能会被录音，我们可能会使用通话录音来监督我们的客服服务质量，检查您所提供的信息的准确性以防止欺诈，或为了我们内部人员培训的目的。录音在被保留一段时间后会自动删除，除非由于合规要求或合法利益需要为场景的保留。</p>
    <p>2.1.9履行义务：处理相关政策下发生的保险索赔和付款，处理支付给合作伙伴的佣金或对服务合作伙伴造成的损失提起索赔或收回付款等。</p>
    <p>2.1.10法律目的：美游美可能需要使用您的信息来处理和解决法律纠纷，或遵循对美游美具有约束力的任何法律法规或监管机构颁发的文件规定，以配合国家部门或监管机构调查和遵从法律法规的目的。</p>
    <p>3.共享、转让、披露的可能性</p>
    <p>此外，我们可能会出于其他目的收集、使用和披露您的个人信息，并通过修订本政策的形式告知您。</p>
    <p>3.1美游美会尽一切合理及可能的方式保护您的个人信息免受侵犯，但您的信息可能会在下列情况下披露：</p>
    <p>3.1.1美游美的合作伙伴：为了确保您订购产品的顺利出行，美游美会将你的必要信息提供给与美游美合作的酒店、景区、航空公司、铁路公司、游轮、汽车服务商、旅行社、代理商快递业务、通讯服务、客户服务、市场推广等机构。</p>
    <p>3.1.2金融机构和第三方支付机构：当您预订订单、申请退款、购买保险时，我们会与金融机构或第三方支付机构共享特定的订单信息，当我们认为用于欺诈检测和预防目的实属必要时，我们将进一步和相关金融机构共享其他必要信息，如IP地址等。</p>
    <p>3.1.3法律法规或国家司法机关、相关监督管理部门的要求：为了国家安全、国防安全、公共安全的需要；与犯罪侦查、起诉、审判和判决执行有关的。</p>
    <p>4.商业推送</p>
    <p>4.1美游美可能会通过您预留的手机号码或邮箱向您发送商业推送信息，提供推广美游美或美游美合作方的产品和服务。</p>
    <p>4.2若您不希望收到商业推送信息，您可以通过我们推送中提供的相应提示，或者手机设备指引，根据指引停止上述推送。</p>
    <p>5.用户的权利和个人信息管理</p>
    <p>5.1您的权利：</p>
    <p>.a)知情权：我们在收集和获取您的个人信息时，向您提供相关途径以便您知晓我们的身份、我们对您个人信息处理目的及方式、权利维护途径等内容。</p>
    <p>.b)访问权：您有权从我们这里确认您的个人信息是否被处理，以及处理目的、保留时间等内容。</p>
    <p>.c)更正权：您有权要求我们无不当延误地更正与您个人信息相关的不准确的数据。</p>
    <p>.d)删除权：您有权要求我们无不当延误地删除与您有关的个人信息，且在特定情形下我们有义务无不当延误地删除您的个人信息。</p>
    <p>.e)限制处理权：在特定情况下，您有权限制我们处理您的个人信息。（您对您个人信息的准确性有疑问，可给与我们一定期限以核实个人信息的准确性）</p>
    <p>.f)可携权：在法律允许的前提下，您可以要求我们将您的个人信息转移给第三方，而我们应在合理范围内尽量配合您的要求。注意：在技术支持和按照当下水平我们能够实现您要求的前提下可配合您行使该权利。</p>
    <p>.g)拒绝权：您有权以正当理由反对我们对您的个人信息进行处理。</p>
    <p>.h)自动化决策权：您有权决定不受基于我们自动化处理行为得出的决定的制约。</p>
    <p>5.2个人信息管理</p>
    <p>.a)访问您的个人信息</p>
    <p>会员信息：如果您希望访问或编辑您的美游美账号中的个人资料信息和支付信息、修改登录密码、修改绑定手机、或者退出登陆等，您可以在美游美手机客户端“我的”或美游美官网“我的美游美”中执行此类操作。</p>
    <p>.</p>
    <p>订单信息：您可以在美游美手机客户端“我的”或美游美官网“我的订单”中查阅您的订单记录、交易记录等。</p>
    <p>.</p>
    <p>如果您无法通过上述路径访问您的个人信息，您可以通过电话400-608-6166与我们取得联系。我们将在30天内回复您的访问请求。</p>
    <p>.</p>
    <p>.b)更正您的个人信息</p>
    <p>当您发现我们处理的关于您的个人信息有错误时，您有权要求我们做出更正补充或完善。您可以通过电话400-608-6166向我们提出更正或补充申请，我们经过评估会配合您的正当请求。</p>
    <p>.</p>
    <p>.c)删除您的个人信息</p>
    <p>在以下情形中，您可以向我们提出删除个人信息的请求：</p>
    <p>.</p>
    <p>.i.如果我们处理个人信息的行为违反法律法规；</p>
    <p>.ii.如果我们收集、使用您的个人信息，却未征得您的明确同意；</p>
    <p>.iii.如果我们处理个人信息的行为严重违反了与您的约定；</p>
    <p>.iv.如果您不再使用我们的产品或服务，或您主动注销了账号；</p>
    <p>.v.如果我们永久不再为您提供产品或服务。</p>
    <p>Ø当您申请删除您的部分或全部信息，包括会员注销账号，您需联系美游美客服400-608-6166。</p>
    <p>Ø当您从我们的服务中删除信息后，我们可能不会立即从备份系统中删除相应的信息，但会在备份更新时删除这些信息。在您主动注销账号之后，我们将停止为您提供产品或服务，根据适用法律法规的要求尽快删除您的个人信息或对其进行匿名化处理。</p>
    <p>Ø请您注意：我们在确定您是账户所有者后15个工作日内，为您注销相关账户。如您在注销后需要再次使用我们服务的，可使用手机号码、邮箱或以美游美网认可的其他方式在达到重新注册标准后再次申请注册账户（账户注销6个月后方可再次申请注册）。</p>
    <p>.d)更改您同意的范围</p>
    <p>我们提供的各业务功能需要一些基本的个人信息才能得以完成。除此之外，对于额外个人信息的收集和使用，您可以通过400-608-6166联系我们给予或收回您的授权同意。当您收回同意后，我们将不再处理相应的个人信息。但您收回同意的决定，不会影响此前基于您的授权而开展的个人信息处理。</p>
    <p>.</p>
    <p>.e)转移个人信息的请求</p>
    <p>当您希望将您个人信息转移至第三方时，您可以通过400-608-6166向我们提出申请，我们会基于法律允许和技术可行的基础来评估配合您进行操作。请您注意对于该项操作可能产生的风险、费用等问题。</p>
    <p>.</p>
    <p>.f)拒绝我们处理的请求</p>
    <p>当您以法律法规政策等规定的正当理由决定拒绝我们对您个人信息进行的相关处理活动时，您可以通过400-608-6166向我们提出申请，由我们进行审核来配合您进行操作。</p>
    <p>.</p>
    <p>.g)约束系统自动决策</p>
    <p>在我们某些业务功能中，我们可能仅依据信息系统、算法等在内的非人工自动决策机制做出决定。如果这些决定显著影响您的合法权益，您有权要求我们做出解释，我们也将在不侵害美游美网商业秘密或其他用户权益、社会公共利益的前提下提供申诉方法。</p>
    <p>.</p>
    <p></p>
    <p>6.关于未成年用户</p>
    <p>6.1美游美非常重视对未成年人个人信息的保护。若您是18周岁以下的未成年人，在使用美游美的服务前，应事先取得您法定监护人的同意。美游美根据《中华人民共和国未成年人保护法》等国家相关法律法规的要求对未成年人的个人信息及隐私进行保护。</p>
    <p>6.2美游美不会主动直接向未成年人收集其个人信息。对于经监护人同意而收集未成年人个人信息的情况，我们仅在法律法规允许、监护人同意或保护未成年人所必要的情况下使用、共享、转让或披露此类信息。</p>
    <p>6.3作为监护人，您可以在APP端登录后，通过“我的”->“常用旅客”对未成人的相关信息进行查询、更正和删除操作。如果有事实证明未成年人并未取得监护人同意的情况下注册和使用了我们的服务，监护人可以联系美游美客服，我们会在确认后尽快删除相关未成年人的个人信息。</p>
    <p>6.4对于不满14周岁的儿童个人信息，我们还会遵循正当必要、知情同意、目的明确、安全保障、依法利用的原则，按照《儿童个人信息网络保护规定》等法律法规的要求进行存储、使用、披露。当您作为监护人为被监护的儿童选择使用美游美相关旅行服务时，我们可能需要向您收集被监护的儿童个人信息，用于向您履行相关服务之必要。如果您不提供前述信息，您将无法享受我们提供的相关服务。此外，您在使用评价功能时可能会主动向我们提供儿童个人信息，请您明确知悉并谨慎选择。您作为监护人应当正确履行监护职责，保护儿童个人信息安全。如您对儿童个人信息相关事宜有任何意见、建议或投诉，请联系我们。</p>
    <p>7.隐私政策的适用于调整</p>
    <p>7.1本《隐私政策》适用于美游美网、美游美APP、美游美M网、美游美小程序。</p>
    <p>7.2美游美保留在适当的时候根据法律法规的要求或美游美自身的需求调整本《隐私政策》的权利。美游美将标注《隐私政策》的更新时间并及时进行发布，本《隐私政策》发布及生效并替代之前的版本。</p>
    <p>8信息安全与保护</p>
    <p>8.1美游美非常重视信息安全，成立了专门的负责团队。我们努力为您提供信息保护，采取了合适的管理、技术以及物理安全措施，参照国内外信息安全标准及最佳实践建立了与业务发展相适应的信息安全保障体系，已获得信息安全管理体系标准认证，符合国家相应的管理政策标准。</p>
    <p>8.2我们从数据的生命周期角度出发，在数据收集、存储、显示、处理、使用、销毁等各个环节建立了安全防护措施，根据信息敏感程度的级别采取不同的控制措施，包括但不限于访问控制、SSL加密传输、敏感信息脱敏显示等。</p>
    <p>8.3我们对可能接触到您信息的员工也采取了严格管理，可监控他们的操作情况，对于数据访问、内外部传输使用、脱敏、解密等重要操作建立了审批机制，并与上述员工签署保密协议等。与此同时，我们还定期对员工进行信息安全培训，要求员工在日常工作中形成良好操作习惯，提升数据保护意识。</p>
    <p>8.4尽管有前述的安全措施，但同时也请您理解在网络上不存在“完善的安全措施”。我们会按现有的技术提供相应的安全措施来保护您的信息，提供合理的安全保障，我们将尽力做到使您的信息不被泄露、损毁或丢失。</p>
    <p>8.5您的账户均有安全保护功能，请妥善保管您的账号及密码信息，切勿将密码告知他人，如果您发现自己的个人信息泄露，特别是您的账号和密码发生泄露，请您立即与我们的客服联系，以便我们采取相应的措施。</p>
    <p>8.6请您及时保存或备份您的文字、图片等其他信息，您需理解并接受，您接入我们的服务所用的系统和通讯网络，有可能因我们可控范围外的因素而出现问题。</p>
    <p>8.7在使用美游美网服务进行网上交易时，请您妥善保护自己的个人信息（包括但不限于出行人姓名、联络方式或联系地址），仅在必要的情形下向他人提供。请使用复杂密码，协助我们保证您的账号安全。我们将尽力保障您发送给我们的任何信息的安全性。为防止他人未经授权使用您的密码或使用您的计算机、移动设备或SIM卡，如您发现自己的个人信息尤其是您的账户或密码发生泄露，请您立即联络美游美网客服，以便我们核实后根据您的申请采取相应措施。</p>
    <p>8.8信息安全事件处置</p>
    <p>在不幸发生个人信息安全事件后，我们将按照法律法规的要求向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。事件相关情况我们将以邮件、信函、电话、推送通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，上报个人信息安全事件的处置情况。</p>
    <p>8.9第三方网站链接/第三方服务</p>
    <p>8.9.1美游美平台内可能包含第三方网站的链接或有独立的第三方提供服务，SDK名录具体见下表。</p>
    <p>SDK名称	详细信息</p>
    <p>支付宝	SDK来源：支付宝（中国）网络技术有限公司</p>
    <p>收集个人信息用途/目的：用于第三方共享登录，支付</p>
    <p>收集的信息范围：设备信息、网络信息、手机外部存储</p>
    <p>收集的信息范围：IOS、Android</p>
    <p>第三方隐私政策或协议链接：<a href="https://opendocs.alipay.com/open/01g6qm">https://opendocs.alipay.com/open/01g6qm</a></p>
    <p>微信	SDK来源：深圳市腾讯计算机系统有限公司</p>
    <p>收集个人信息用途/目的：用于第三方共享登录，分享，支付</p>
    <p>收集的信息范围：设备标识符、网络信息</p>
    <p>收集的信息范围：IOS、Android</p>
    <p>第三方隐私政策或协议链接：<a href="https://privacy.tencent.com">https://privacy.tencent.com</a></p>
    <p>腾讯QQ	SDK来源：深圳市腾讯计算机系统有限公司</p>
    <p>收集个人信息用途/目的：用于第三方共享登录，分享</p>
    <p>收集的信息范围：设备信息</p>
    <p>涉及App系统：IOS、Android</p>
    <p>第三方隐私政策或协议链接：<a href="https://privacy.tencent.com/">https://privacy.tencent.com/</a></p>
    <p>微博	SDK来源：北京微梦创科网络技术有限公司</p>
    <p>收集个人信息用途/目的：用于分享</p>
    <p>收集的信息范围：设备信息</p>
    <p>涉及App系统：IOS、Android</p>
    <p>第三方隐私政策或协议链接：<a href="https://m.weibo.cn/c/privacy">https://m.weibo.cn/c/privacy</a></p>
    <p>GT3（极验）	SDK来源：武汉极意网络科技有限公司</p>
    <p>收集个人信息用途/目的：用于业务数据支撑</p>
    <p>收集的信息范围：IP信息</p>
    <p>涉及App系统：IOS、Android</p>
    <p>第三方隐私政策或协议链接：<a href="https://www.geetest.com/Private">https://www.geetest.com/Private</a></p>
    <p>云闪付	SDK来源：中国银联股份有限公司</p>
    <p>收集个人信息用途/目的：中国银联股份有限公司使用云闪付支付</p>
    <p>收集的信息范围：个人信息、设备信息</p>
    <p>收集的信息范围：IOS、Android</p>
    <p>第三方隐私政策或协议链接：<a href="https://open.unionpay.com/">https://open.unionpay.com/</a></p>
    <p>ApplePay	SDK来源：中国银联股份有限公司</p>
    <p>收集个人信息用途/目的：使用ApplePay支付</p>
    <p>收集的信息范围：个人信息、设备信息</p>
    <p>收集的信息范围：IOS、Android</p>
    <p>第三方隐私政策或协议链接：<a href="https://www.apple.com.cn/privacy/">https://www.apple.com.cn/privacy/</a></p>
    <p>OCR证件扫描	SDK来源：上海合合信息科技发展有限公司</p>
    <p>收集个人信息用途/目的：用于绑定银行卡的OCR识别身份证</p>
    <p>收集的信息范围：个人信息、设备信息</p>
    <p>收集的信息范围：IOS、Android</p>
    <p>第三方隐私政策或协议链接：<a href="https://s.intsig.net/r/terms/PP_CamScanner_zh-cn.html">https://s.intsig.net/r/terms/PP_CamScanner_zh-cn.html</a></p>
    <p>微信	SDK来源：深圳市腾讯计算机系统有限公司</p>
    <p>收集个人信息用途/目的：用于第三方共享登录，分享，支付</p>
    <p>收集的信息范围：设备标识符、网络信息</p>
    <p>收集的信息范围：IOS、Android</p>
    <p>第三方隐私政策或协议链接：<a href="https://privacy.tencent.com">https://privacy.tencent.com</a></p>
    <p>BUGLY	SDK来源：深圳市腾讯计算机系统有限公司</p>
    <p>收集个人信息用途/目的：用于收集app闪退信息</p>
    <p>收集的信息范围：设备信息</p>
    <p>收集的信息范围：IOS、Android</p>
    <p>第三方隐私政策或协议链接：<a href="https://bugly.qq.com/v2/contract">https://bugly.qq.com/v2/contract</a></p>
    <p>神策	SDK来源：神策网络科技(北京)有限公司</p>
    <p>收集个人信息用途/目的：用于收集APP内用户行为数据，用于统计数据服务。</p>
    <p>收集的信息范围：设备信息</p>
    <p>收集的信息范围：IOS、Android</p>
    <p>第三方隐私政策或协议链接：<a href="https://www.sensorsdata.cn/market/privacy_policy.html">https://www.sensorsdata.cn/market/privacy_policy.html</a></p>
    <p>友盟	SDK来源：友盟同欣（北京）科技有限公司</p>
    <p>收集个人信息用途/目的：用于收集APP内用户行为数据，用于统计数据服务，并推送产品信息、订单信息、出行信息通知。</p>
    <p>收集的信息范围：设备信息</p>
    <p>收集的信息范围：IOS、Android</p>
    <p>第三方隐私政策或协议链接：<a href="https://www.umeng.com/page/policy">https://www.umeng.com/page/policy</a></p>
    <p>百度定位	SDK来源：百度在线网络技术(北京)有限公司</p>
    <p>收集个人信息用途/目的：用于获取用户定位</p>
    <p>收集的信息范围：设备信息、经纬度信息</p>
    <p>收集的信息范围：IOS、Android</p>
    <p>第三方隐私政策或协议链接：<a href="http://lbsyun.baidu.com/index.php?title=open/privacy">http://lbsyun.baidu.com/index.php?title=open/privacy</a></p>
    <p>腾讯X5	SDK来源：深圳市腾讯计算机系统有限公司</p>
    <p>收集个人信息用途/目的：用于提供浏览器服务</p>
    <p>收集的信息范围：设备信息</p>
    <p>收集的信息范围：Android</p>
    <p>第三方隐私政策或协议链接：<a href="https://x5.tencent.com/tbs/guide/develop.html#5">https://x5.tencent.com/tbs/guide/develop.html#5</a></p>
    <p>为使此类链接清晰可用，通常当您点击链接时，您的浏览器将为链接另外打开一个新窗口。通常我们会为跳转提供提示（您将离开美游美网或类似措辞）。为了您的更佳服务体验，在某些情况下，独立的第三方服务可能镶嵌在本公司网站内（或者以专栏或频道的方式显示），但会在第三方服务提供者承担责任的页面部分的页首或页末进行提示（显示其不同于美游美网的经营主体或版权所有者的名称或提示“由某某提供服务”或poweredby某某/servicesprovidedby某某等类似措辞）。我们建议您仔细阅读所有从您那里收集信息的每一个第三方网站链接和第三方服务提供者的信息。</p>
    <p>请您注意：这些第三方网站链接或第三方服务由其他公司或组织所有或负责运营，如果您使用该第三方链接或第三方服务者的服务时向其提供您的个人信息，您的信息应当适用该第三方或第三方服务者的隐私政策或类似声明，我们对任何第三方不当使用或披露由您提供的信息不承担任何法律责任。对此类第三方网站链接或第三方服务的访问与使用所产生的风险完全由您自行承担。</p>
    <p>三、管辖</p>
    <p>本服务条款及隐私政策之效力、解释、执行均适用中华人民共和国法律，因本服务条款及隐私政策所引起的一切法律纠纷，均有上海市长宁区人民法院管辖。</p>
    <p>四、账号注销规则</p>
    <p>根据工信部《电信和互联网用户个人信息保护规定》第九条的规定，除非法律、行政法规另有规定，电信业务经营者、互联网信息服务提供者在用户终止使用电信服务或者互联网信息服务后，应当停止对用户个人信息的收集和使用，并为用户提供注销号码或者账号的服务。</p>
    <p>故如您需要账号注销，请通过400-608-6166与美游美联系，我们将安排给您做账号注销处理流程，账号注销后美游美网将不再保留您的个人信息及历史订单等数据，并无法提供数据恢复服务。如需再次使用，请您重新注册新账号使用。</p>
    <p>五、您如何联系我们</p>
    <p>如您对本隐私政策或您个人信息的相关事宜有任何问题、投诉、意见或建议，请通过tqc@springtour.com邮件或电话400-608-6166与我们取得联系。</p>
    <p>如果您对我们的联系服务不满意，特别是我们的个人信息处理行为损害了您的合法权益，一般情况下，我们将在十五个工作日内回复。同时您还可以向网信办、消费者保护协会等监管部门进行投诉，投诉方式如下：</p>
    <p>国家网信办举报中心：www.12377.cn</p>
    <p>消费者投诉举报电话：12315</p>
    <p>美游美投诉电话：400-608-6166</p>
    <p>六、法律适用于管辖</p>
    <p>6.1不管您为中华人民共和国境内还是境外的用户，协议条款之订立、效力、解释、修订、补充、执行与争议解决均适用中华人民共和国大陆地区的系列法律法规（不包括冲突法）。</p>
    <p>6.2本协议签订地为中华人民共和国上海市长宁区。若您和美游美之间因本协议产生任何纠纷或争议，首先应友好协商解决；协商不成的，您同意将纠纷或争议提交本协议签订地有管辖权的人民法院管辖。</p>
    <p>6.3本协议适用的法律文件清单包括但不限于：</p>
    <p>《中华人民共和国民法典》</p>
    <p>《中华人民共和国网络安全法》</p>
    <p>《中华人民共和国著作权法》</p>
    <p>《中华人民共和国商标法》</p>
    <p>《中华人民共和国电子签名法》</p>
    <p>《中华人民共和国电子商务法》</p>
    <p>《信息安全技术个人信息安全规范》</p>
    <p>发布日期2021年11月16日------ 更新日期2021年11月16日</p>
  </section>
</template>

<script>

export default {
  name: 'PrivacyPolicy',
  data() {}
}
</script>

<style lang="scss" scoped>
p {
  padding: 0 24px;
  width: calc(100% - 48px);
  font-size: 16px;
  line-height: 30px;
}
a {
  text-decoration: underline;
}
</style>